var render = function render(){var _vm=this,_c=_vm._self._c;return _c('keep-alive',[_c(_vm.renderedComponent,_vm._b({tag:"component",on:{"close":function($event){return _vm.$emit('close')}}},'component',{ boxed: _vm.boxed, closable: _vm.closable, conversation: _vm.conversation, visible: _vm.visible },false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }